module.exports = __webpack_public_path__ + "static/media/test17_4.c3a02650.png";